import axiosInstance, { endpoints } from 'src/utils/axios';

import { CONFIG } from 'src/config-global';

import { createListHook, createResourceActions } from '../utils/create-action';


// ----------------------------------------------------------------------

const reportsEndpoint = endpoints.me.inStoreReports;


const customActions = {
    // Custom action for generating reports
    async generateInStoreReport(reportId, storeIds, reportDate, format) {
        const endpoint = endpoints.c.inStoreReports.generate(reportId);

        const url = new URL(`${CONFIG.site.serverUrl}${endpoint}`);

        url.searchParams.append('store_ids', storeIds);
        url.searchParams.append('report_date', reportDate);
        url.searchParams.append('file_format', format);

        const responseType = {
            csv: 'text',
            pdf: 'blob',
        }[format] || 'text';

        const response = await axiosInstance.get(url.toString(), {
            responseType
        });

        if (response.status === 400) {
            throw new Error('No data available for the selected parameters');
        }

        if (response.status === 204) {
            return null;
        }

        return response.data;

    },

    // InStore Report Categories - returns list with count
    useGetInStoreReportCategories(args = { params: { size: 1000 } }) {
        return createListHook(endpoints.c.inStoreReportCategories.list)(args);
    }
};


// Create standardized actions for InStore Reports
export const inStoreReportsActions = createResourceActions(reportsEndpoint.list, {
    customActions
});

const {
    create: createMeInStoreReport,
    delete: deleteMeInStoreReport,
    get: useGetMeInStoreReport,
    list: useGetMeInStoreReports,
    update: updateMeInStoreReport,
} = inStoreReportsActions;

// Export all report actions
export {
    createMeInStoreReport,
    deleteMeInStoreReport,
    updateMeInStoreReport,
    useGetMeInStoreReport,
    useGetMeInStoreReports,
};

export const {
    generateInStoreReport,
    useGetInStoreReportCategories
} = customActions;
